import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Icon } from '../components/Icon.jsx';

const STATUS = { ok: ['ok', 'check', 'In Ordnung'], fehlt: ['warn', 'warn', 'Fehlt'], hinweis: ['info', 'warn', 'Hinweis'] };

/**
 * «Ist die Firma startklar?» – nur auf Knopfdruck (kostet einige Exxas-Aufrufe). Zeigt, was in Exxas oder in den
 * Einstellungen noch fehlt, mit Hinweis, wo man es behebt.
 */
export function Pruefung({ online }) {
  const q = useQuery({ queryKey: ['verwaltung', 'pruefung'], queryFn: () => api('/verwaltung/pruefung', { timeoutMs: 60_000 }), enabled: false, retry: false });
  const punkte = q.data?.punkte ?? [];
  const offen = punkte.filter((p) => p.status !== 'ok').length;
  return (
    <>
      <section className="card stack" style={{ gap: 12 }}>
        <p className="sub" style={{ fontSize: 14 }}>Prüft, ob eure Firma eingerichtet ist: Markierungen in Exxas, Rollen, Material, Abgleich. Dauert ein paar Sekunden.</p>
        <button type="button" className="btn lg block" onClick={() => q.refetch()} disabled={!online || q.isFetching}>
          {q.isFetching ? 'Prüft …' : q.data ? 'Nochmals prüfen' : 'Jetzt prüfen'}
        </button>
        {q.isError && <div className="notice err" role="alert">{q.error.message}</div>}
        {q.data && <span className="sub" role="status" style={{ fontWeight: 700 }}>{offen ? `${offen} ${offen === 1 ? 'Punkt' : 'Punkte'} offen` : 'Alles startklar'}</span>}
      </section>
      {punkte.length > 0 && (
        <section className="card list" style={{ padding: '4px 16px' }} aria-label="Ergebnis der Prüfung">
          {punkte.map((p) => {
            const [art, icon, text] = STATUS[p.status] ?? STATUS.hinweis;
            return (
              <div key={p.id} className="listrow" style={{ alignItems: 'flex-start' }}>
                <span className="stack" style={{ gap: 2, flex: 1, minWidth: 0 }}>
                  <span style={{ fontWeight: 800 }}>{p.titel}</span>
                  <span className="sub" style={{ fontSize: 13, overflowWrap: 'anywhere' }}>{p.text}</span>
                </span>
                <span className={`pill ${art}`}><Icon name={icon} size={14} stroke={2.6} />{text}</span>
              </div>
            );
          })}
        </section>
      )}
    </>
  );
}
